import React from 'react';
import CardModule from './CardModule';
import freightflow from '../assets/Vibe coding/Freightflow.png';
import radix from '../assets/Vibe coding/Radix.png';
import focusedJobApps from '../assets/Vibe coding/FocusedJobApplications.svg';
import aifStudyDrill from '../assets/Vibe coding/AifStudyDrill.svg';

const VibeCodingExperiments = () => {
  const vibeCodingCards = [
    {
      title: "AWS AI Practitioner prep tool",
      description: "118 original practice questions for the AWS Certified AI Practitioner exam across three modes: flashcards that make you commit to an answer before flipping, 20-question mock rounds, and a scenario-to-service match-up. Missed cards resurface a few turns later, and progress saves in the browser.",
      image: aifStudyDrill,
      link: "/aws-ai-practitioner/",
      external: true,
      date: "2026",
      category: "Web App • AWS Certification Prep"
    },
    {
      title: "Focused Job Applications",
      description: "A Python CLI that automates the research and drafting side of personalized cold outreach for job applications. Scrapes fresh design postings, finds the right recruiter at each company, drafts a tailored email with resume attached, and lands it as a Gmail draft for manual review — never auto-sends.",
      image: focusedJobApps,
      link: "https://github.com/chidrupa99/Focused-Job-Applications",
      external: true,
      date: "2026",
      category: "Python CLI • Outreach Automation"
    },
    {
      title: "Radix Color Variables Plugin",
      description: "Built a Figma plugin to import and generate Radix color palettes as Light/Dark mode variables, including alpha variants. Streamlined theming workflows for designers by automating color token creation and organization.",
      image: radix,
      link: "https://www.figma.com/community/plugin/1512563076799262933/radix-color-palette",
      external: true,
      date: "2025",
      category: "Figma Plugin • Radix"
    },
    {
      title: "FreightFlow",
      description: "FreightFlow is a comprehensive web application designed to help logistics planners build and optimize multi-leg freight shipments. It features a modern 3-column responsive layout with AI-powered suggestions and risk assessment.",
      image: freightflow,
      link: "https://chidrupa.notion.site/FreightFlow-Logistics-Planning-App-21c25017dc6480f2bc66d775afc09ad1?source=copy_link",
      external: true,
      date: "2025",
      category: "Web App • Logistics • Amazon"
    },
  ];

  return (
    <div className="tab-content">
      <CardModule cards={vibeCodingCards} />
    </div>
  );
};

export default VibeCodingExperiments; 